import moment from 'moment'

import { FormatsManager } from './formatting'
import { getCurrentLanguage } from './locale'

const formats = () => FormatsManager.getFormats()

const THAI_LANGUAGE_CODE = 'th'
const THAI_YEAR_OFFSET = 543

const shiftThaiYear = (momentObj) => {
    return getCurrentLanguage() === THAI_LANGUAGE_CODE ?
        moment(momentObj).add(THAI_YEAR_OFFSET, 'year') :
        momentObj
}

const isoToLocalFormattedDateByFormat = (isoString, format) => {
    return shiftThaiYear(moment.utc(isoString)).local().format(format)
}

export const isoToFormattedLocalDateTime = (isoString) => {
    return isoToLocalFormattedDateByFormat(isoString, formats().datetime)
}

export const isoToFormattedLocalDate = (isoString) => {
    return isoToLocalFormattedDateByFormat(isoString, formats().shortDate)
}

export const isoToFormattedLocalFullDate = (isoString) => {
    return isoToLocalFormattedDateByFormat(isoString, formats().fullDate)
}

export const isoToFormattedLocalFullMonth = (isoString) => {
    return isoToLocalFormattedDateByFormat(isoString, formats().fullMonth)
}

export const isoToFormattedLocalTime = (isoString) => {
    return isoToLocalFormattedDateByFormat(isoString, formats().time)
}

const unixToFormattedLocalDateByFormat = (timestamp, format) => {
    return shiftThaiYear(moment.unix(timestamp)).local().format(format)
}

export const unixToFormattedLocalDateTime = (timestamp) => {
    return unixToFormattedLocalDateByFormat(timestamp, formats().datetime)
}

export const unixToFormattedLocalDate = (timestamp) => {
    return unixToFormattedLocalDateByFormat(timestamp, formats().shortDate)
}

export const unixToFormattedLocalTime = (timestamp) => {
    return unixToFormattedLocalDateByFormat(timestamp, formats().time)
}

export const getShiftedIsoString = (seconds) => {
    return seconds ? moment().add(seconds, 'seconds').toISOString() : null
}

export const daysSinceDate = (date) => {
    return moment().diff(moment(date).local(), 'days')
}

const getDurationSinceTimestamp = (timestamp) => {
    const date = moment.unix(timestamp).local()
    return moment.duration(moment().diff(date))
}

const findLocalizedDuration = (duration, localizations) => {
    const type = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'].find((step) => duration[step]())
    return localizations[type](duration[type]())
}

export const getTimeSinceTimestamp = (timestamp, localizations = {}) => {
    const duration = getDurationSinceTimestamp(timestamp)
    return findLocalizedDuration(duration, localizations)
}

export const isDateAfter = (date, compareTo = new Date()) => moment.utc(date).isAfter(moment.utc(compareTo))

export const formatDateAgoWith = (date, translations) => {
    const momentObj = moment(date)
    if (momentObj.clone().local().isSame(moment(), 'day')) {
        return translations.today
    } else if (momentObj.clone().local().isSame(moment().add(1, 'days'), 'day')) {
        return translations.tomorrow
    }
    return isoToFormattedLocalDate(date)
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/helpers/datetime.js